export const CREATE_SCHEDULE_ACTION = 'CREATE_SCHEDULE';
export const CAMPAIGN_FORM_UPDATE_TEMPLATE_DETAIL = 'CAMPAIGN_FORM_UPDATE_TEMPLATE_DETAIL';
export const CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL = 'CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL';
export const CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL = 'CAMPAIGN_FORM_UPDATE_SCHEDULE_DETAIL';
export const CAMPAIGN_FORM_UPDATE = 'CAMPAIGN_FORM_UPDATE';
export const CAMPAIGN_FORM_ERROR = 'CAMPAIGN_FORM_ERROR';
export const UPDATE_CURRENT_FORM_STEP = 'UPDATE_CURRENT_FORM_STEP';
export const UPDATE_FORM_VALIDATION = 'UPDATE_FORM_VALIDATION';
export const CLEAR_CAMPAIGN_FORM = 'CLEAR_CAMPAIGN_FORM';
export const UPDATE_FORM_SUBMISSION_STATUS = 'UPDATE_FORM_SUBMISSION';
export const TEST_EMAIL_ACTION = 'TEST_EMAIL_ACTION';
export const UPDATE_TEST_EMAIL_DETAILS = 'UPDATE_TEST_EMAIL_DETAILS';
export const GET_ALL_CAMPAIGNS = 'GET_ALL_CAMPAIGNS';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
